import React, { useState, useEffect } from "react";

const AddExpense = ({ tripId, onExpenseAdded }) => {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [members, setMembers] = useState([]);
  const [sharedWith, setSharedWith] = useState([]);
  const [currency, setCurrency] = useState("GBP");
  const [currencySymbol, setCurrencySymbol] = useState("£");
  const [currencies, setCurrencies] = useState([]);
  const [payerId, setPayerId] = useState("");
  const [needSplit, setNeedSplit] = useState(true);
  const [expenseType, setExpenseType] = useState("");
  const [paidDate, setPaidDate] = useState("");

	useEffect(() => {
	  const fetchCurrencies = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
		  const token = localStorage.getItem("token");
		  const response = await fetch(`${process.env.REACT_APP_API_URL}/countries/countries/`);
		  if (response.ok) {
			const data = await response.json();
			//console.log("Fetched countries: ", data);

			const uniqueCurrencies = [];
			const seenCodes = new Set();

			for (const c of data) {
			  if (c.code && !seenCodes.has(c.code)) {
				seenCodes.add(c.code);
				uniqueCurrencies.push(c);
			  }
			}

			const priorityCodes = ["GBP", "EUR", "USD", "TWD", "JPY", "HKD"];

			const prioritized = uniqueCurrencies.filter(c => priorityCodes.includes(c.code));
			const others = uniqueCurrencies
			  .filter(c => !priorityCodes.includes(c.code))
			  .sort((a, b) => a.code.localeCompare(b.code));

			setCurrencies([...prioritized, ...others]);
		  } else {
			console.error("Failed to fetch currencies");
		  }
		} catch (error) {
		  console.error("Error fetching currencies", error);
		}
	  };

	  fetchCurrencies();
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	
  useEffect(() => {
    const fetchMembers = async () => {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/tripmembers/trip_members/${tripId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.ok) {
        const data = await response.json();
		setMembers(data.filter((m) => m.user_id != null));
      } else {
        console.error("Unable to get member list");
      }
    };

    fetchMembers();
	// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripId]);
  
  // 全選成員
  const selectAllMembers = () => {
    if (sharedWith.length === members.length) {
      setSharedWith([]); // 如果已經全選，則清除選擇
    } else {
      setSharedWith(members.map((member) => Number(member.user_id))); // 否則全選
    }
  };

  // 新增費用
  const addExpense = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please Login");
      return;
    }

    if (sharedWith.length === 0) {
      alert("Choose atleast one member");
      return;
    }

    // console.log("🚀 sharedWith = ", sharedWith);
	// console.log("members = ", members);

	const expenseData = {
	  trip_id: parseInt(tripId),
	  amount: parseFloat(amount),
	  description,
	  payer_id: payerId,
	  shared_with: needSplit ? sharedWith : [payerId], // 不split就只有payer一個人
	  currency,
	  currency_symbol: currencySymbol,
	  is_shared_with_all: sharedWith.length === members.length,
	  type: expenseType || null,
	  paid_date: paidDate || null  
	};

	// console.log("expenseData = ", expenseData);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/expenses/split_expense/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(expenseData),
        }
      );

      if (response.ok) {
        alert("Expense added successfully!");
        setAmount("");
        setDescription("");
        setSharedWith([]);
        onExpenseAdded?.();
      } else {
        const errorData = await response.json();
        alert("Failed to add expense：" + JSON.stringify(errorData));
      }
    } catch (error) {
      alert("Request Error：" + error.message);
    }
  };

  return (
	<div className="p-4 border rounded-lg shadow-md bg-white responsive-container">
		<div className="mb-2">
		  <label className="form-label">Type</label>
		  <select
			value={expenseType}
			onChange={(e) => setExpenseType(e.target.value)}
			className="form-input"
		  >
			<option value="">Select Type</option>
			{["Flights", "Lodging", "Transit", "Car rental", "Food", "Sightseeing", "Activities", "Shopping", "Gas", "Groceries", "Other"].map((type) => (
			  <option key={type} value={type}>{type}</option>
			))}
		  </select>
		</div>
		<div className="mb-2">
		  <label className="form-label">Paid Date (optional)</label>
		  <input
			type="date"
			value={paidDate}
			onChange={(e) => setPaidDate(e.target.value)}
			className="form-input"
		  />
		</div>	  
	  <div className="mb-2">
		<label className="form-label">Payer</label>		
		<select
		  value={payerId}
		  onChange={(e) => setPayerId(Number(e.target.value))}
		  className="form-input"
		>
		  <option value="">Select Payer</option>
		  {members.map((member) => (
			<option key={member.user_id} value={member.user_id}>
			  {member.username || member.name || `User ${member.user_id}`}
			</option>
		  ))}
		</select>
	</div>		
	  <div className="flex flex-col sm:flex-row gap-2 mb-2">
	  <select
		value={currency}
		onChange={(e) => {
		  const selected = currencies.find(c => c.code === e.target.value);
		  setCurrency(selected.code);
		  setCurrencySymbol(selected.symbol);
		}}
		className="form-input sm:w-1/3"
	  >
		{currencies.map((c) => (
		  <option key={c.code} value={c.code}>
			{c.code} ({c.symbol})
		  </option>
		))}
	  </select>

	  <input
		type="number"
		value={amount}
		onChange={(e) => setAmount(e.target.value)}
		placeholder="Amount"
		className="form-input flex-1"
	  />
	</div>
      <input
        type="text"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Description"
        className="form-input mb-2"
      />
		<div className="flex items-center mb-2">
		  <input
			type="checkbox"
			checked={needSplit}
			onChange={(e) => setNeedSplit(e.target.checked)}
			className="mr-2 accent-primary"
		  />
		  <label className="text-gray-700">Need to split?</label>
		</div>
      <label className="form-label">Select apportionment member(s)：</label>

      {/* 全選/清除按鈕 */}
      <div className="flex gap-2 mb-2">
        <button
          type="button"
          onClick={selectAllMembers}
          className="bg-secondary text-white px-3 py-1 rounded hover:bg-green-700 text-sm"
        >
          {sharedWith.length === members.length ? "Unselect All" : "Select All"}
        </button>
      </div>

      {/* 成員清單 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 max-h-40 overflow-y-auto mb-4">
        {members.map((member) => (
		  <div key={member.user_id} className="flex items-center space-x-2">
			<input
			  id={`member-${member.user_id}`}
			  type="checkbox"
			  checked={sharedWith.includes(Number(member.user_id))}
			  onChange={(e) => {
				const numericId = Number(member.user_id);
				if (e.target.checked) {
				  setSharedWith((prev) => {
					const updated = [...prev, numericId];
					return Array.from(new Set(updated)); // 去除重複
				  });
				} else {
				  setSharedWith((prev) => prev.filter((uid) => uid !== numericId));
				}
			  }}
			  className="cursor-pointer"
			/>
			<label htmlFor={`member-${member.user_id}`} className="cursor-pointer">
			  {member.username || member.name || `使用者 ${member.user_id}`}
			</label>
		  </div>
		))}
      </div>

      <button
        onClick={addExpense}
        className="btn-full bg-primary text-white p-2 rounded-lg hover:bg-orange-600 mt-2"
      >
        Add Expense
      </button>
    </div>
  );
};

export default AddExpense;